import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withRouter } from 'react-router'
import _ from 'lodash'
import { injectIntl, defineMessages } from 'react-intl'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  loadLessonDetail,
  clearLessonDetail,
  vocabularyStudied,
  vocabularyAnswerCreate,
} from '../../common/lessons/actions'
import { subscribe } from '../../common/users/actions'
import { TextInput, Button, FacebookShare } from '../components'

function getOptionsQuestion(words, word) {
  const filteredWords = words.map(w => w.foreignWord[0])
                             .filter(w => w !== word.foreignWord[0])

  const shuffled = filteredWords.sort(() => 0.5 - Math.random())
  const selected = shuffled.slice(0, 3)

  const correctIndex = Math.floor(Math.random() * 5)
  selected.splice(correctIndex, 0, word.foreignWord[0])

  return selected
}

class VocabularyLearnPage extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      progress: 0,
      firstLevelTarget: 100,
      target: 100,
      current: null,
      selected: null,
      queueInit: false,
      queue: [],
      level: 1,
      answered: false,
      result: false,
      finished: false,
      userAnswer: '',
      subscriberEmail: '',
      subscribed: false,
    }

    this.wordInput = React.createRef()
  }

  componentDidMount() {
    const { loadLessonDetail, match } = this.props

    if (match && match.params.id) {
      loadLessonDetail(match.params.id)
    }

    const self = this
    document.addEventListener('keyup', (e) => {
      if (e.keyCode === 13) {
        if (self.state.answered) {
          self.continue()
        } else if (self.state.level > 1) {
          self.checkAnswer(self.state.userAnswer)
        }
      }
    })
  }

  componentWillReceiveProps(nextProps) {
    const { currentLesson } = nextProps

    if (currentLesson && !this.state.queueInit) {
      const queue = []

      const { words } = currentLesson

      _.shuffle(words).forEach(word => {
        const options = getOptionsQuestion(words, word)

        queue.push({
          foreignWord: word.foreignWord[0],
          baseWord: word.baseWord,
          options,
        })
      })

      const current = queue[0]

      this.setState({
        queueInit: true,
        queue,
        current,
        firstLevelTarget: queue.length,
        target: queue.length * 2,
      })
    }
  }

  componentDidCatch(error, info) {
    console.log('error - VocabularyLearnPage')
    console.log(error)
    console.log('info')
    console.log(info)
  }

  componentDidUpdate() {
    if (this.wordInput && this.wordInput.current) {
      this.wordInput.current.focus()
    }
  }

  componentWillUnmount() {
    // this.props.clearLessonDetail()
  }

  isCorrectAnswer(selected, foreign) {
    const { level } = this.state
    const userAnswer = selected.toLowerCase().trim()

    if (level === 2) {
      for (let f of foreign) {
        if (userAnswer === f.toLowerCase().trim()) {
          return true
        }
      }

      return false
    }

    return selected.toLowerCase().trim() === foreign.toLowerCase().trim()
  }

  checkAnswer(selected) {
    const { vocabularyAnswerCreate, currentLesson, userIp, countryCode, viewer } = this.props
    const { current, queue, progress, level } = this.state
    let newQueue = [...queue]
    newQueue.shift()

    const isCorrect = this.isCorrectAnswer(selected, current.foreignWord)

    if (!isCorrect && level === 1) {
      newQueue = [...newQueue, { ...current, options: _.shuffle(current.options) }]
    } else if (!isCorrect) {
      newQueue = [...newQueue, current]
    }

    vocabularyAnswerCreate({
      lesson: currentLesson.id,
      baseWord: current.baseWord,
      foreignWord: current.foreignWord,
      isCorrect,
      userIp,
      countryCode,
      step: progress,
      user: viewer,
    })

    this.setState({
      queue: newQueue,
      answered: true,
      result: isCorrect,
      progress: progress + (isCorrect ? 1 : 0),
      selected,
    })
  }

  continue() {
    const { progress, target, level, queue, firstLevelTarget } = this.state
    const { currentLesson, vocabularyStudied, viewer, history, userIp, countryCode } = this.props
    const { words } = currentLesson

    let newQueue = queue
    let newLevel = level
    const finishedFirstLevel = progress === firstLevelTarget && level === 1
    const finished = progress === target

    const newPath = `/vocabulary-learn/${currentLesson.id}/${progress}`

    history.push(newPath)

    if (finishedFirstLevel) {
      newQueue = _.shuffle(words)
      newLevel = 2
    }

    if (level > 1 && !finished) {
      vocabularyStudied(currentLesson.id, { userIp, countryCode, user: viewer })
    }

    this.setState({
      current: newQueue[0],
      answered: false,
      selected: null,
      userAnswer: '',
      finished,
      queue: newQueue,
      level: newLevel,
    })

    if (finished && !viewer) {
      history.push('/subscribe')
    }
  }

  skip() {
    /* add current to end + shift */
    const { queue, current } = this.state
    let newQueue = [...queue]
    newQueue.shift()

    newQueue = [...newQueue, current]

    this.setState({
      queue: newQueue,
      current: newQueue[0],
    })
  }

  reset() {
    const { words } = this.props.currentLesson
    const queue = []

    _.shuffle(words).forEach(word => {
      const options = getOptionsQuestion(words, word)

      queue.push({
        foreignWord: word.foreignWord[0],
        baseWord: word.baseWord,
        options,
      })
    })

    this.setState({
      progress: 0,
      level: 1,
      userAnswer: '',
      selected: null,
      answered: false,
      finished: false,
      current: queue[0],
      queue,
    })
  }

  updateUserAnser(e) {
    this.setState({
      userAnswer: e.target.value,
    })
  }

  render() {
    const { viewer, currentLesson, registeringUser, subscribe, intl } = this.props
    const { current, answered, level, result, progress, target,
      selected, finished, userAnswer } = this.state

    if (!currentLesson) return null

    return (
      <div className="vocabulary-learn-page width-full">
        {/* CLOSE + TITLE */}
        <header>
          {
            registeringUser ?
              <Link
                className="vocabulary-learn-page-close back"
                to="/sign-up"
              >
                <FontAwesomeIcon icon="arrow-left" size="2x" />
              </Link>
            :
              <Link
                className="vocabulary-learn-page-close"
                to={`/lessons/${currentLesson.id}`}
              >
                <FontAwesomeIcon icon="times-circle" size="2x" />
              </Link>
          }
          <h2>{`${currentLesson.name}`}</h2>
          {
            registeringUser &&
            <Link className="skip-button" to="/sign-up-form">
              <Button>{intl.formatMessage(messages.skip)}</Button>
            </Link>
          }
        </header>
        {/* PROGRESS BAR */}
        <div className="vocabulary-learn-page-slider">
          <div
            className="vocabulary-learn-page-slider-fill"
            style={{
              width: `${(progress / target) * 100}%`,
            }}
          >
            &nbsp;
          </div>
        </div>
        {/* OPTIONS */}
        {
          !finished && current &&
          <div className="vocabulary-learn-page-body">
            {
              current.options ?
                <React.Fragment>
                  <h3>{intl.formatMessage(messages.chooseCorrect)} {current.baseWord}</h3>
                  <div className="vocabulary-learn-page-body-options">
                    {
                      current.options.map((option, index) => (
                        <Button
                          key={`${option}${index}`}
                          positive={result && option === selected}
                          negative={!result && option === selected}
                          onClick={() => {
                            if (!answered) {
                              this.checkAnswer(option)
                            }
                          }}
                        >
                          {option}
                        </Button>
                      ))
                    }
                  </div>
                </React.Fragment>
              :
                <React.Fragment>
                  <h3>{intl.formatMessage(messages.translate)} {current.baseWord}</h3>
                  <div>
                    <TextInput
                      inputRef={this.wordInput}
                      value={userAnswer}
                      disabled={answered}
                      placeholder={intl.formatMessage(messages.enterAnswer)}
                      onChange={(e) => this.updateUserAnser(e)}
                    />
                  </div>
                </React.Fragment>
            }
          </div>
        }
        {/* CONTROL PANEL */}
        <div className={`vocabulary-learn-page-control ${answered ? (result ? 'correct' : 'incorrect') : ''}`}>
          <div className="vocabulary-learn-page-control-wrapper width-container">
            {
              answered ?
                (result ?
                  <div className="vocabulary-learn-page-control-correct">
                    <p><b>{intl.formatMessage(messages.correct)}</b></p>
                  </div>
                :
                  <div className="vocabulary-learn-page-control-incorrect">
                    <p>{intl.formatMessage(messages.incorrect)}</p>
                    <p>{intl.formatMessage(messages.correctIs)} <b>{typeof current.foreignWord == 'string' ? current.foreignWord: current.foreignWord[0]}</b></p>
                  </div>
                )
              :
                  level > 1 && !answered &&
                  <Button
                    big
                    onClick={() => this.skip()}
                  >
                    {intl.formatMessage(messages.skip)}
                  </Button>
            }
            <Button
              disabled={level < 2 && !answered}
              className="vocabulary-learn-page-control-main-button"
              onClick={() => {
                if (answered) {
                  this.continue()
                } else {
                  this.checkAnswer(userAnswer)
                }
              }}
              big
              positive
            >
              {(answered || level < 2) ?
                intl.formatMessage(messages.continue)
              : intl.formatMessage(messages.check)}
            </Button>
          </div>
        </div>
        {/* COMPLETE SCREEN */}
        {
          finished && progress === target &&
          <div className="vocabulary-learn-page-complete">
            <h3>{intl.formatMessage(messages.congratulations)}</h3>
            <div className="vocabulary-learn-page-complete-links">
              <Link onClick={() => this.reset()} to="#">
                {intl.formatMessage(messages.studyAgain)}
              </Link>
              <Link to={`/lessons/${currentLesson.id}`}>
                {intl.formatMessage(messages.showDetail)}
              </Link>
            </div>
            <div>
              {
                viewer ?
                  <React.Fragment>
                    <Link to="/app/lessons">
                      <Button positive className="spacing-top">
                        {intl.formatMessage(messages.lessonsList)}
                      </Button>
                    </Link>
                  </React.Fragment>
                :
                  <React.Fragment>
                    <p>{intl.formatMessage(messages.subscribeMessage)}</p>
                    {
                      this.state.subscribed ?
                        <p>
                          {intl.formatMessage(messages.subscriptionThanks)}
                        </p>
                      :
                        <React.Fragment>
                          <TextInput
                            placeholder={intl.formatMessage(messages.subscribePlaceholder)}
                            value={this.state.subscriberEmail}
                            onChange={(e) =>
                              this.setState({ subscriberEmail: e.target.value })}
                          />
                          <Button
                            positive
                            className="disable-spacing-left"
                            onClick={() => {
                              this.setState({ subscriberEmail: '', subscribed: true })
                              subscribe({
                                email: this.state.subscriberEmail,
                                lesson: currentLesson.id,
                                progress: currentLesson.words.length,
                              })
                            }
                            }
                          >
                            {intl.formatMessage(messages.subscribeButton)}
                          </Button>
                        </React.Fragment>
                    }
                    {/*
                    <Link to={registeringUser ? '/sign-up-form' : '/sign-up'}>
                      <Button className="vertical-spacing" big positive>
                        {intl.formatMessage(messages.createNewWordsSet)}
                      </Button>
                    </Link>
                    */}
                  </React.Fragment>
              }
            </div>
          </div>
        }
      </div>
    )
  }
}

VocabularyLearnPage.defaultProps = {
  currentLesson: null,
  match: null,
  viewer: null,
  registeringUser: null,
  isPopup: false,
}

VocabularyLearnPage.propTypes = {
  intl: PropTypes.object.isRequired,
  loadLessonDetail: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  clearLessonDetail: PropTypes.func.isRequired,
  vocabularyStudied: PropTypes.func.isRequired,
  vocabularyAnswerCreate: PropTypes.func.isRequired,
  subscribe: PropTypes.func.isRequired,
  currentLesson: PropTypes.object,
  match: PropTypes.object,
  viewer: PropTypes.object,
  registeringUser: PropTypes.object,
}

VocabularyLearnPage = withRouter(VocabularyLearnPage)

const enhance = compose(
  connect(state => ({
    viewer: state.users.viewer,
    lessons: state.lessons.all,
    currentLesson: state.lessons.currentLesson,
    registeringUser: state.users.registeringUser,
    userIp: state.app.userIp,
    countryCode: state.app.countryCode,
  }), { subscribe, loadLessonDetail, clearLessonDetail,
    vocabularyStudied, vocabularyAnswerCreate }),
  injectIntl,
)

export default enhance(VocabularyLearnPage)

const messages = defineMessages({
  correct: {
    id: 'vocabularyLearn.page.correct',
    defaultMessage: 'Správne!',
  },
  incorrect: {
    id: 'vocabularyLearn.page.incorrect',
    defaultMessage: 'Nesprávne :(',
  },
  chooseCorrect: {
    id: 'vocabularyLearn.page.chooseCorrect',
    defaultMessage: 'Vyberte správny preklad slova: ',
  },
  translate: {
    id: 'vocabularyLearn.page.translate',
    defaultMessage: 'Napíšte preklad slova: ',
  },
  enterAnswer: {
    id: 'vocabularyLearn.page.enterAnswer',
    defaultMessage: 'Vložte Vašu odpoveď',
  },
  correctIs: {
    id: 'vocabularyLearn.page.correctIs',
    defaultMessage: 'Správna odpoveď je: ',
  },
  skip: {
    id: 'vocabularyLearn.page.skip',
    defaultMessage: 'Preskočiť',
  },
  check: {
    id: 'vocabularyLearn.page.check',
    defaultMessage: 'Skontrolovať',
  },
  continue: {
    id: 'vocabularyLearn.page.continue',
    defaultMessage: 'Pokračovať',
  },
  congratulations: {
    id: 'vocabularyLearn.page.congratulations',
    defaultMessage: 'Výborne. Len tak ďalej :)',
  },
  lessonsList: {
    id: 'vocabularyLearn.page.lessonsList',
    defaultMessage: 'Vybrať iné cvičenie',
  },
  createNewWordsSet: {
    id: 'vocabularyLearn.page.createNewWordsSet',
    defaultMessage: 'Vytvoriť nový zoznam',
  },
  searchexercise: {
    id: 'vocabularyLearn.page.searchexercise',
    defaultMessage: 'Nájsť ďalšie cvičenia',
  },
  studyAgain: {
    id: 'vocabularyLearn.page.studyAgain',
    defaultMessage: 'Študovať znovu',
  },
  showDetail: {
    id: 'vocabularyLearn.page.showDetail',
    defaultMessage: 'Zobraziť slovíčka',
  },
  subscribeMessage: {
    id: 'vocabularyLearn.page.subscribeMessage',
    defaultMessage: 'Naučte sa 100 nových slovíčok. Vložte email a zašleme Vám nové slovíčka.',
  },
  subscribePlaceholder: {
    id: 'vocabularyLearn.page.subscribePlaceholder',
    defaultMessage: 'Vložte Váš email',
  },
  subscribeButton: {
    id: 'vocabularyLearn.page.subscribeButton',
    defaultMessage: 'Odoslať',
  },
  subscriptionThanks: {
    id: 'vocabularyLearn.page.subscriptionThanks',
    defaultMessage: 'Ďakujeme!',
  },

})



// WEBPACK FOOTER //
// ./src/browser/pages/VocabularyLearnPage.js